import { OrganizationScope, RegionScope, Scope } from "~/hooks/useScope";

export type PolicyAssignScope = RegionScope | OrganizationScope;

export function buildScopedUrl(path: string, scope: Scope): string {
  const params = scope.params.toString();
  return params ? `${path}?${params}` : path;
}
